import MuiAccordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import useId from '../../hooks/useId'
import Icon from '../Icon'
import {
  AccordionHeader,
  AccordionSubtitle,
  AccordionTitle
} from './Accordion.styles'
import { IAccordionArgs } from './Accordion.types'

const Accordion = ({
  expanded = false,
  title,
  subtitle,
  id,
  icon = <Icon name="MdKeyboardArrowDown" />,
  children,
  'data-testid': testid = 'accordion',
  onChange = () => {}
}: IAccordionArgs) => {
  const handleOnChange =
    (panel: string = id) =>
    (event: React.SyntheticEvent, isExpanded: boolean) => {
      onChange({ event, isExpanded, panel })
    }
  const { getTestId } = useId(testid)

  return (
    <MuiAccordion
      disableGutters
      expanded={expanded}
      id={id}
      onChange={handleOnChange(id)}
      data-testid={getTestId()}>
      <AccordionHeader
        expandIcon={icon}
        aria-controls={id}
        data-testid={getTestId('summary')}>
        <AccordionTitle>{title}</AccordionTitle>
        <AccordionSubtitle>{subtitle}</AccordionSubtitle>
      </AccordionHeader>
      <AccordionDetails data-testid={getTestId('detail')}>
        {children}
      </AccordionDetails>
    </MuiAccordion>
  )
}

export default Accordion
